import { SupportedNetwork, toBitcoinNetwork } from "@cat-protocol/cat-sdk";
import { AddressType } from 'sats-connect';

import * as bitcoin from "bitcoinjs-lib";

import {
    CAT20Covenant,
} from '@cat-protocol/cat-sdk';

import Decimal from 'decimal.js';

export function getTokenContractP2TR(minterP2TR: string) {
    return new CAT20Covenant(minterP2TR).lockingScriptHex;
}

export function scaleByDecimals(amount: bigint, decimals: number) {
    return amount * BigInt(Math.pow(10, decimals));
}

export function unScaleByDecimals(amount: string, decimals: number): string {
    return new Decimal(amount)
        .div(Math.pow(10, decimals))
        .toFixed(decimals);
}

export function formatUnisatNetwork(chain: {
    enum: string,
    name: string,
    network: string,
}): SupportedNetwork {


    switch (chain.enum) {
        case 'FRACTAL_BITCOIN_MAINNET':
            return 'fractal-mainnet';
        case 'FRACTAL_BITCOIN_TESTNET':
            return 'fractal-testnet';
        default:
            throw new Error(`Invalid network \`${chain.name}\`, please switch to Fractal network in wallet`)
    }
}



export function getAddressType(address: string, network: SupportedNetwork): AddressType {
    const _network = toBitcoinNetwork(network)
    try {
        const decoded = bitcoin.address.fromBase58Check(address);
        if (decoded.version === _network.pubKeyHash) {
            return AddressType.p2pkh;
        } else if (decoded.version === _network.scriptHash) {
            return AddressType.p2sh;
        }
    } catch (e) {
        try {
            const decoded = bitcoin.address.fromBech32(address);
            if (decoded.prefix === 'bc' || decoded.prefix === 'tb') {
                if (decoded.version === 0) {
                    if (decoded.data.length === 20) {
                        return AddressType.p2wpkh;
                    } else if (decoded.data.length === 32) {
                        return AddressType.p2wsh;
                    }
                } else if (decoded.version === 1) {
                    return AddressType.p2tr;
                }
            }
        } catch (e) {
            throw new Error('Invalid address');
        }
    }
    throw new Error('Unknown address type');
}

export function toNetworkLabel(network: SupportedNetwork) {
    if (network === 'btc-signet') {
        return "BTC Signet";
    } else if (network === "fractal-testnet") {
        return "Fractal Bitcoin Testnet"
    } else if (network === "fractal-mainnet") {
        return "Fractal Bitcoin"
    }
}
